module.exports = __webpack_public_path__ + "img/sld_abt_meter_dark.8a342e6a.svg";